<div #dialogContent></div>
<scaffold-dialog [title]="data.title">
  <div scaffoldDialogBody>
    <iframe
      #iframe
      style="width: 100%; height: 100%; border: none; min-height: 65vh"
      [style.display]="content ? 'block' : 'none'"
    ></iframe>
    <div *ngIf="!content && lmss.length > 1">
      <p-select ngDefaultControl [options]="lmss" [(ngModel)]="lms" [placeholder]="'select_lms_for_tool'| translation" />
    </div>
  </div>
  <div scaffoldDialogButtons *ngIf="!content && lmss.length > 1">
    <div></div>
    <button pButton severity="primary" (click)="setLMS(lms)" [disabled]="!lms">
      {{ "launch"| translation }}
    </button>
  </div>
</scaffold-dialog>
